import { Injectable, NgZone, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class TabNotificationService implements OnDestroy {

  private flashInterval: ReturnType<typeof setInterval> | null = null;
  private showingPreview = false;
  private unreadCount = 0;
  private visibilityHandler = () => this.onVisibilityChange();

  private static readonly BASE_TITLE = 'Crewdle Connect';
  private static readonly FLASH_INTERVAL_MS = 2000;

  constructor(
    private title: Title,
    private ngZone: NgZone,
  ) {
    document.addEventListener('visibilitychange', this.visibilityHandler);
  }

  ngOnDestroy(): void {
    this.stopFlashing();
    document.removeEventListener('visibilitychange', this.visibilityHandler);
  }

  public update(unreadCount: number): void {
    this.unreadCount = unreadCount;

    if (unreadCount === 0) {
      this.stopFlashing();
      this.title.setTitle(TabNotificationService.BASE_TITLE);
      return;
    }

    const countTitle = this.buildCountTitle();
    this.title.setTitle(countTitle);

    if (document.visibilityState === 'hidden') {
      this.startFlashing();
    } else {
      this.stopFlashing();
    }
  }

  // --- Tab title flashing ---

  private startFlashing(): void {
    if (this.flashInterval) {
      return;
    }

    this.showingPreview = false;
    this.ngZone.runOutsideAngular(() => {
      this.flashInterval = setInterval(() => {
        this.showingPreview = !this.showingPreview;

        const text = this.showingPreview
          ? 'Unread messages'
          : this.buildCountTitle();

        this.ngZone.run(() => this.title.setTitle(text));
      }, TabNotificationService.FLASH_INTERVAL_MS);
    });
  }

  private stopFlashing(): void {
    if (this.flashInterval) {
      clearInterval(this.flashInterval);
      this.flashInterval = null;
    }
    this.showingPreview = false;
  }

  private onVisibilityChange(): void {
    if (document.visibilityState === 'visible') {
      this.stopFlashing();
      const text = this.unreadCount > 0
        ? this.buildCountTitle()
        : TabNotificationService.BASE_TITLE;
      this.ngZone.run(() => this.title.setTitle(text));
    } else if (this.unreadCount > 0) {
      this.startFlashing();
    }
  }

  private buildCountTitle(): string {
    const display = this.unreadCount > 99 ? '99+' : this.unreadCount;
    return `(${display}) ${TabNotificationService.BASE_TITLE}`;
  }

}
